import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "color", "icon", "direction", "position", "textProps"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { TextBase } from "../internal/TextBase";
import styles from './CardLabel.css';
var cx = classNames.bind(styles);
var defaultTextProps = {
  color: 'W100',
  weight: 'semibold'
};
export var CardLabel = /*#__PURE__*/forwardRef(function CardLabel(_ref, ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'G600' : _ref$color,
      icon = _ref.icon,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'bottomLeft' : _ref$direction,
      position = _ref.position,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? defaultTextProps : _ref$textProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('root', "direction_".concat(direction), "color_".concat(color), _defineProperty({
      has_position: position
    }, "position_".concat(position), position)),
    ref: ref
  }), children && /*#__PURE__*/React.createElement("div", {
    className: cx('text')
  }, /*#__PURE__*/React.createElement(TextBase, textProps, children)), icon && /*#__PURE__*/React.createElement("span", {
    className: cx('icon')
  }, icon));
});
export default CardLabel;